import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TeslaSymbols} from "../../../config/TeslaSymbols";
import {Tesla} from "../../Tesla";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {MathHelper} from "../../utils/MathHelper";
import {StateMatrix} from "../../utils/StateMatrix";
import {TimelineLite} from "gsap";

/**
 * Created by h3 on 2017-10-18.
 */
export class TeslaBonusHighlightSpinAnimation {

    private static INVALID_SYMBOLS:string[] = ["B", "S", "W"];

    public static getHighlightSpinAnimation(spinData:string[]):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(spinData == null) {
            console.warn("HighlightSpinData is null");
            return tl;
        }

        let highlightAnimations:TimelineLite[] = TeslaBonusHighlightSpinAnimation.getSpinStateAnimations(spinData);
        for(let i:number = 0; i < highlightAnimations.length; i++) {
            const timeScale = Math.min(6, (highlightAnimations.length * 1.3) / (i + 1));
            tl.add([
                highlightAnimations[i].timeScale(timeScale),
                () => Tesla.soundPlayer.playHighlightSound(i % 3)
            ]);
        }
        return tl;
    }

    public static getHighlightWinAnimation(winSymbol:string):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            TeslaBonusHighlightSpinAnimation.getSpinStateAnimation(winSymbol, [0, 11]),
            () => Tesla.soundPlayer.playHighlightSound(0)
        ]);
        return tl;
    }

    public static createFakeSpinData(symbolMatrix:StateMatrix<string>, winSymbolId:string):string[] {
        let spinData:string[] = symbolMatrix.visibleStates.concat();
        let nonIndex = spinData.indexOf("none");
        if(nonIndex >= 0) {
            spinData.splice(nonIndex, 1);
        }

        while(spinData.length < 10) {
            spinData = spinData.concat(spinData);
        }
        spinData = MathHelper.shuffleArray(spinData);
        spinData = spinData.slice(0, 10);

        //Check so that the last fake one is not the same as the winning one.
        const lastItem:string = spinData.pop()!;
        if(lastItem == winSymbolId) {
            spinData.unshift(lastItem);
        } else {
            spinData.push(lastItem);
        }
        return spinData;
    }

    public static removeInvalidSymbolIds(symbolMatrix:StateMatrix<string>) {
        for(let invalidSymbol of TeslaBonusHighlightSpinAnimation.INVALID_SYMBOLS) {
            symbolMatrix.swapState(invalidSymbol, "none");
        }
        return symbolMatrix;
    }

    public static getSpinStateAnimations(spinData:string[]) {
        const winSymStateTls:TimelineLite[] = [];
        for(let i = 0; i < spinData.length; i++) {
            winSymStateTls.push(TeslaBonusHighlightSpinAnimation.getSpinStateAnimation(spinData[i]));
        }
        return winSymStateTls;
    }

    public static getSpinStateAnimation(symbolId:string, customAnimFrames?:number[]):TimelineLite {
        const frames:number[] = customAnimFrames ? customAnimFrames : [0, 11, 0];
        const tl:TimelineLite = new TimelineLite();

        for(let i:number = 0; i < 5; i++) {
            for(let j:number = 0; j < 3; j++) {
                let symbol:StateReelSymbol | null = Reels.getSymbol(i, j);
                if(symbol == null) {
                    continue;
                }
                if(symbol.symName == TeslaSymbols.B) {
                    continue;
                }
                if(symbol.symName == symbolId) {
                    tl.add(symbol.changeState({
                        state : TeslaGameConfig.instance.SYMBOL_STATES.win,
                        frames : frames
                    }), 0);
                } else {
                    tl.add(symbol.changeState({
                        state : TeslaGameConfig.instance.SYMBOL_STATES.noWin,
                    }), 0);
                }
            }
        }
        return tl;
    }
}